function n() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
function o() {
  return /windows/.test(navigator.userAgent.toLowerCase());
}
function t() {
  const e = navigator.userAgent.toLowerCase();
  return /iphone|ipad/i.test(e) || /safari/.test(e) && !/chrome/.test(e) && n();
}
function i() {
  const e = navigator.userAgent.toLowerCase();
  return /android/.test(e) && n();
}
function r() {
  return /iphone|android/.test(navigator.userAgent.toLowerCase());
}
function c() {
  const e = navigator.userAgent.toLowerCase();
  return /iphone/.test(e) && !/ipad/.test(e);
}
function s() {
  return /iPad/i.test(navigator.userAgent);
}
function a() {
  return "dscef" in window;
}
function u() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || t();
}
function d() {
  return navigator.userAgent.includes("Firefox");
}
export {
  i as checkIsAndroidDevice,
  r as checkIsAndroidOrIphoneDevice,
  d as checkIsFirefoxBrowser,
  a as checkIsInRichClient,
  s as checkIsIpadDevice,
  c as checkIsIphoneDevice,
  t as checkIsIphoneOrIpadDevice,
  u as checkIsMobileDevice,
  n as checkIsTouchDevice,
  o as checkIsWindowsDevice
};
